module.exports = __webpack_public_path__ + "img/bin.d33534f7.svg";